import 'abortcontroller-polyfill';
import { FunctionComponent } from 'preact/compat';

// import './index.scss';
import ErrorBoundary from './newtab/ErrorBoundary';
import NewTab from './newtab';

const App: FunctionComponent = () => (
  <ErrorBoundary
    name="global"
    message="There was a critical error. We were notified about the problem and we
          will try to fix it as soon as possible. Please try to refresh the page
          and if it does not help reinstall the extension."
  >
    <NewTab />
  </ErrorBoundary>
);

export default App;
